import { BadgeMultiselect, LabelsPicker } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { LabelType } from '@interfaces/models';
import { Button } from '@ui/components';

import { EmployeesBulkDeleteDialog } from './employee-bulk-delete-dialog/employees-bulk-delete-dialog';
import { useEmployeeBulkActions } from './use-employee-bulk-actions';

export const EmployeeBulkActions = ({
  onEmployeeRemove,
  selectedRows,
}: {
  onEmployeeRemove: () => void;
  selectedRows: string[];
}) => {
  const { t } = useTranslation();

  const {
    employeeProfilesOptions,
    isAddDepartmentOpen,
    isAddProfileOpen,
    isDeleteOpen,
    isPendingProfiles,
    isPendingLabels,
    isPendingDelete,
    bulkEditEmployeeProfilesMutation,
    bulkEditEmployeesDeleteMutation,
    bulkEditEmployeeLabelsMutation,
    setIsAddDepartmentOpen,
    setIsAddProfileOpen,
    setIsDeleteOpen,
  } = useEmployeeBulkActions({
    onEmployeeRemoveSuccess: onEmployeeRemove,
  });

  return (
    <div className="flex items-center gap-1 mb-2 px-1">
      <LabelsPicker
        onSave={(labels) => bulkEditEmployeeLabelsMutation({ labels, employeeIds: selectedRows })}
        searchPlaceholder={t('EMPLOYEES.BULK_ADD_DEPARTMENT_SEARCH_PLACEHOLDER')}
        saveButtonLabel={t('EMPLOYEES.BULK_ADD_DEPARTMENT')}
        setIsOpen={setIsAddDepartmentOpen}
        labelType={LabelType.EMPLOYEE}
        isOpen={isAddDepartmentOpen}
        isLoading={isPendingLabels}
        asChild
      >
        <Button variant="ghost">{t('EMPLOYEES.BULK_ADD_DEPARTMENT')}</Button>
      </LabelsPicker>

      <BadgeMultiselect
        onSave={(profiles) =>
          bulkEditEmployeeProfilesMutation({ profiles, employeeIds: selectedRows })
        }
        searchPlaceholder={t('EMPLOYEES.BULK_ADD_PROFILE_SEARCH_PLACEHOLDER')}
        buttonLabel={t('EMPLOYEES.BULK_ADD_PROFILE')}
        options={employeeProfilesOptions}
        setIsOpen={setIsAddProfileOpen}
        isLoading={isPendingProfiles}
        isOpen={isAddProfileOpen}
      >
        <Button variant="ghost">{t('EMPLOYEES.BULK_ADD_PROFILE')}</Button>
      </BadgeMultiselect>

      <Button onClick={() => setIsDeleteOpen(true)} variant="ghost">
        {t('EMPLOYEES.BULK_DELETE')}
      </Button>

      <EmployeesBulkDeleteDialog
        onRemove={() => bulkEditEmployeesDeleteMutation({ employeeIds: selectedRows })}
        onClose={() => setIsDeleteOpen(false)}
        isPending={isPendingDelete}
        isOpen={isDeleteOpen}
      />
    </div>
  );
};
